module.exports = __webpack_public_path__ + "static/media/homepage_service.c76e8ad8.svg";